import { render, staticRenderFns } from "./ChatOrderListPanel.vue?vue&type=template&id=67732d2a&scoped=true&"
import script from "./ChatOrderListPanel.vue?vue&type=script&lang=js&"
export * from "./ChatOrderListPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderListPanel.vue?vue&type=style&index=0&id=67732d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67732d2a",
  null
  
)

export default component.exports